export * from './actions';
export * from './effects';
export * from './service';

export { featureKey as policiesKey, initialState as policiesInitialState, State as PoliciesState } from './reducer';

export {
  getData as policiesGetData,
  getError as policiesGetError,
  getLoading as policiesGetLoading,
  mapData as policiesMapData,
} from './selectors';
